export default __webpack_public_path__ + "static/media/marker-orange-yellow.ad67f976.png";